import React from 'react'
import styled from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { colors } from '~/design'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;

  img {
    width: 100%;
    height: 165px;
    object-fit: cover;
  }

  .text {
    padding: 15px;
  }

  .bottom {
    display: flex;
    justify-content: flex-end;
    padding: 10px 15px 15px;

    a {
      display: flex;
      align-items: center;
      gap: 5px;
      font-weight: bold;
      padding: 2px 8px;
      background: ${colors.sebraeBlue};
      color: #fff;
      border-radius: 10px;
      transition: transform 0.2s ease-in-out;

      &:hover {
        transform: scale(1.05);
      }
    }
  }
`

export default function StudyGridItemCourseDropout() {
  return (
    <Wrapper>
      <div>
        <img src='https://images.unsplash.com/photo-1502465771179-51f3535da42c?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D' />
        <div className='text'>
          <span>Um estudo sobre evasão de cursos a nível nacional e estadual.</span>
        </div>
      </div>
      <div className='bottom'>
        <a href={'/app/report/course-dropout'}>
          ver mais
          <FontAwesomeIcon icon={faArrowRight} color='#fff' />
        </a>
      </div>
    </Wrapper>
  )
}
